import { render, staticRenderFns } from "./NoticeManageView.vue?vue&type=template&id=69618fde&scoped=true"
import script from "./NoticeManageView.vue?vue&type=script&lang=js"
export * from "./NoticeManageView.vue?vue&type=script&lang=js"
import style0 from "./NoticeManageView.vue?vue&type=style&index=0&id=69618fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69618fde",
  null
  
)

export default component.exports